(function () {
    // ── Total header height: take max bottom across all sticky/header-group elements ──
    function updateTotalHeaderHeight() {
        var candidates = [
            document.querySelector('sticky-header'),
            document.querySelector('.shopify-section-header-sticky')
        ].concat(Array.from(document.querySelectorAll('.shopify-section-group-header-group')));

        var maxBottom = 0;
        candidates.forEach(function (el) {
            if (!el) return;
            var b = el.getBoundingClientRect().bottom;
            if (b > maxBottom) maxBottom = b;
        });

        // Fallback: use header offsetHeight if nothing gave a positive result
        if (maxBottom <= 0) {
            var header = document.querySelector('header');
            if (header) maxBottom = header.offsetHeight;
        }

        document.documentElement.style.setProperty('--berndorf-total-header-height', maxBottom + 'px');
    }

    // Run after full page load so fonts/images don't shift layout
    window.addEventListener('load', updateTotalHeaderHeight);
    window.addEventListener('resize', updateTotalHeaderHeight);

    // Track every header search: mobile and desktop have separate instances.
    // A shared CSS lock avoids one instance unlocking another open overlay.
    function syncSearchScrollLock() {
        var open = !!document.querySelector('.berndorf-header-search[open]');
        if (open && !document.documentElement.classList.contains('berndorf-search-open')) {
            updateTotalHeaderHeight();
        }
        document.documentElement.classList.toggle('berndorf-search-open', open);
    }

    function observePredictiveSearch() {
        var observer = new MutationObserver(syncSearchScrollLock);
        document.querySelectorAll('predictive-search.berndorf-header-search').forEach(function (ps) {
            observer.observe(ps, { attributes: true, attributeFilter: ['open'] });
        });
        syncSearchScrollLock();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', observePredictiveSearch);
    } else {
        observePredictiveSearch();
    }

    // The dropdown's counts come from sections/predictive-search.liquid, which counts only
    // series leads (the products it shows). Until 28.09.2026 a script here overwrote them
    // from a `search.berndorf-count` template that never existed: every tab read (0).

    // ── Close search ─────────────────────────────────────────────────
    function closeSearch(ps) {
        if (!ps) return;
        var input = ps.querySelector('input[type="search"]');
        if (input) {
            input.value = '';
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.blur();
        }
        ps.close();
    }

    // ── Click handler ─────────────────────────────────────────────────
    document.addEventListener('click', function (e) {
        if (e.target.closest('.berndorf-predictive-close')) {
            closeSearch(e.target.closest('predictive-search'));
            return;
        }

        var tab = e.target.closest('.berndorf-search-tab');
        if (!tab) return;

        e.preventDefault();
        e.stopPropagation();

        var resultsEl = tab.closest('#predictive-search-results');
        if (!resultsEl) return;

        var activeTab = tab.dataset.tab;

        resultsEl.querySelectorAll('.berndorf-search-tab').forEach(function (t) {
            t.classList.toggle('is-active', t === tab);
        });

        resultsEl.querySelectorAll('.berndorf-search-section').forEach(function
            (section) {
            var show = activeTab === 'all' || section.dataset.section ===
                activeTab;
            section.style.display = show ? '' : 'none';
        });
    });
})();

/* ── Mobile: Tap auf das Suche-Icon blendet das vollbreite Suchfeld ein ──
   Auf Touch gibt es kein Hover/Focus-Expand wie am Desktop. Das Icon in der
   Utility-Leiste dient daher als Toggle, der die auf Mobile ausgeblendete
   Suchzeile (.berndorf-header__search-row) einblendet und fokussiert. */
(function () {
    var mq = window.matchMedia('(max-width: 1059px)');

    function bind() {
        var buttons = document.querySelectorAll(
            '.berndorf-header-utility__item--search .berndorf-header-search__submit'
        );
        buttons.forEach(function (btn) {
            if (btn.dataset.mobileSearchToggle) return;
            btn.dataset.mobileSearchToggle = '1';
            btn.addEventListener('click', function (e) {
                var header = btn.closest('.berndorf-header');
                var ps = btn.closest('predictive-search');

                // MOBILE: Icon toggelt die vollbreite Suchzeile
                if (mq.matches) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (!header) return;
                    var row = header.querySelector('.berndorf-header__search-row');
                    var rowInput = row && row.querySelector('input[type="search"]');
                    var open = header.classList.toggle('is-search-open');
                    if (open) {
                        if (rowInput) { window.setTimeout(function () { rowInput.focus(); }, 0); }
                    } else {
                        if (rowInput) {
                            rowInput.value = '';
                            rowInput.dispatchEvent(new Event('input', { bubbles: true }));
                            rowInput.blur();
                        }
                        var rowPs = row && row.querySelector('predictive-search');
                        if (rowPs) { rowPs.close(); }
                    }
                    return;
                }

                // DESKTOP: bei offenem Overlay wirkt das Icon als X (Schliessen)
                if (ps && ps.hasAttribute('open')) {
                    e.preventDefault();
                    var di = ps.querySelector('input[type="search"]');
                    if (di) {
                        di.value = '';
                        di.dispatchEvent(new Event('input', { bubbles: true }));
                        di.blur();
                    }
                    ps.close();
                    return;
                }

                // DESKTOP geschlossen + leeres Feld: fokussieren statt leeres Formular abzuschicken
                var input = ps && ps.querySelector('input[type="search"]');
                if (input && !input.value.trim()) {
                    e.preventDefault();
                    input.focus();
                }
                // sonst: normales Submit (Suche mit Begriff)
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bind);
    } else {
        bind();
    }
})();
